import Cache from './Cache';

export default class PostCache {
    _axios = null;
    _cachedUrls = null;
    _cache = null;

    constructor(axios, cachedUrls) {
        this._axios = axios;
        this._cache = new Cache();

        if (!axios) {
            throw new ReferenceError('You must pass axios or axios instance')
        }


    }

    setCachedUrls(cachedUrls) {
        this._cachedUrls = cachedUrls;

        if (!cachedUrls) {
            throw new ReferenceError('c\'mon, man')
        }

        if (!Array.isArray(cachedUrls)) {
            throw new TypeError('the cached urls must be an array')
        }

        if (cachedUrls.some(elem => {
            if (!elem) {
                return true
            }

            if (Array.isArray(elem)) {
                return true
            }

            if (typeof elem === 'object') {
                if (!elem.url) {
                    return true
                }
            } else if (typeof elem !== 'string') {
                return true
            }
        })) {
            throw new TypeError('Please, provide only objects (with a url) or a string')
        }
    }

    async post(url, body, config) {
        if (!body) {
            throw ReferenceError('You must provide a body for a post request (even if it is empty)')
        }

        if (typeof body !== 'object' || Array.isArray(body)) {
            throw TypeError('The body must be an object (even if it is empty)')
        }

        let cacheable = false

        this._cachedUrls.forEach(elem => {
            if (typeof elem === 'string') {
                if (url.includes(elem)) {
                    cacheable = elem
                }
            } else {
                if (url.includes(elem.url)) {
                    cacheable = elem
                }
            }
        })

        if (cacheable) {
            let cached = null

            if (typeof cacheable === 'string') {
                cached = this._cache.get(cacheable)
            } else {
                cached = this._cache.get(cacheable.url, body, config, cacheable.queryParams, cacheable.bodyParams)
            }

            if (cached) {
                return Promise.resolve({
                    data: cached,
                    status: 200,
                    statusText: 'OK',
                    headers: {},
                    request: {}
                })
            } else {

                if(!window.providerCalls)
                    window.providerCalls = 1;
                else
                    window.providerCalls += 1;
    
                //console.log(`PROVIDER # OF CALLS SO FAR ${window.providerCalls}`);
                
                const response = await this._axios.post(url, body, config)
                this._cache.set(response, cacheable.queryParams, cacheable.bodyParams, url)

                return response
            }
        }

        return this._axios.post(url, body, config)
    }

    async get(url, config) {

        let cacheable = false

        this._cachedUrls.forEach(elem => {
            if (typeof elem === 'string') {
                if (url.includes(elem)) {
                    cacheable = elem
                }
            } else {
                if (url.includes(elem.url)) {
                    cacheable = elem
                }
            }
        })

        if (cacheable) {
            let cached = null
            const queryKeys = {}

            if (typeof cacheable === 'string') {
                cached = this._cache.get(cacheable)
            } else {

                if (cacheable.queryParams) {
                    if (Array.isArray(cacheable.queryParams) && config) {
                        cacheable.queryParams.forEach(elem => {
                            queryKeys[elem] = config.params[elem]
                        })
                    } else if (config) {
                        throw new TypeError('QueryParams must be an array')
                    }
                }
                if (Object.keys(queryKeys).length > 0) {
                    cached = this._cache.get(url, undefined, config, queryKeys, undefined)
                } else {
                    cached = this._cache.get(cacheable)
                }
            }

            if (cached) {
                return Promise.resolve({
                    data: cached,
                    status: 200,
                    statusText: 'OK, cached',
                    headers: {},
                    request: {}
                })
            } else {
                const response = await this._axios.get(url, config)
                if (Object.keys(queryKeys).length > 0) {
                    this._cache.set(response, queryKeys, undefined, url)
                } else {
                    this._cache.set(response)
                }
                return response
            }
        }

        return this._axios.get(url, config)
    }

    flushAll() {
        this._cache.flushAll()
    }
}